import React from "react";
import { cn } from "@/lib/utils";

// Base skeleton element - reusable across components
interface SkeletonElementProps {
  className?: string;
  style?: React.CSSProperties;
}

const SkeletonElement: React.FC<SkeletonElementProps> = ({ className, style }) => (
  <div
    className={cn(
      "bg-gradient-to-r from-cede-bg-component via-cede-bg-component-hover to-cede-bg-component bg-[length:200%_100%] animate-pulse rounded",
      className,
    )}
    style={style}
  />
);

export { SkeletonElement };
